/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChallengeRealmCountryResponse
 */
export interface ChallengeRealmCountryResponse {
    /**
     * The Realm-provided country of residence (trimmed full name, e.g. "United States") for pre-selecting the Country picker. Null when Realm has no country on file for this UUID or the lookup fails. The user still confirms it; eligibility country is always user-declared. Client maps the name to its ISO picker option.
     * @type {string}
     * @memberof ChallengeRealmCountryResponse
     */
    country: string | null;
}

/**
 * Check if a given object implements the ChallengeRealmCountryResponse interface.
 */
export function instanceOfChallengeRealmCountryResponse(value: object): value is ChallengeRealmCountryResponse {
    if (!('country' in value) || value['country'] === undefined) return false;
    return true;
}

export function ChallengeRealmCountryResponseFromJSON(json: any): ChallengeRealmCountryResponse {
    return ChallengeRealmCountryResponseFromJSONTyped(json, false);
}

export function ChallengeRealmCountryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeRealmCountryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'country': json['country'],
    };
}

export function ChallengeRealmCountryResponseToJSON(json: any): ChallengeRealmCountryResponse {
    return ChallengeRealmCountryResponseToJSONTyped(json, false);
}

export function ChallengeRealmCountryResponseToJSONTyped(value?: ChallengeRealmCountryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'country': value['country'],
    };
}

